import { GridView, Response } from '../viewManagerTypes';
import { ViewApi } from './Common/ViewApi';

class GridViewApi extends ViewApi<GridView> {
    urlPath: string = '/grid-view';
    async viewByViewName(viewName: string, bootgridName: string): Promise<GridView> {
        try {
            const response = await fetch(`${this.urlPath}/exists/${viewName}/${bootgridName}`);
            if (response.ok) {
                const record: Response<GridView> = await response.json();
                return record.data;
            } else {
                throw new Error(`An error occurred ${response.status}`);
            }
        } catch (error) {
            throw new Error(`An error occurred ${error}`);
        }

    }
    async getDefaultGridView(bootgridName: string): Promise<GridView> {
        try
        {
            const response = await fetch(`${this.urlPath}/default/${bootgridName}`);
            if (response.ok) {
                const record: Response<GridView> = await response.json();
                if (record.message === 'No view found') {
                    return null;
                }
                return record.data;
            } else {
                throw new Error(`An error occurred ${response.status}`);
            }
        } catch (error) {
            throw new Error(`An error occurred ${error}`);
        }
    }
}

export const gridViewApi = new GridViewApi();